import script from "./BotaoMenuLateral.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoMenuLateral.vue?vue&type=script&setup=true&lang=js"

import "./BotaoMenuLateral.vue?vue&type=style&index=0&id=2fc9e364&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc9e364"]])

export default __exports__